import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
/* Imports :: Config */
import config from './config';

/* Imports :: Components */
import Home from './pages/Home';
import Document from './pages/Document';
import SignUp from './pages/SignUp';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import ConfirmEmailPage from './pages/ConfirmEmail';
import MyAccount from './pages/MyAccount';
import BookmarksPage from './pages/Bookmarks';
import SelectPlans from './pages/SelectPlans';
import SearchPage from './pages/Search';
import Persistence from './Persistence';
import Query from './pages/Query';

const AppRoute = () => {
  return (
    <React.Fragment>
      <Router>
        <Switch>
          <Route
            path='/app/my-account/update-subscription'
            exact
            component={() => (
              <Persistence>
                <SelectPlans />
              </Persistence>
            )}
          />
          <Route
            path='/app/my-account/select-plans'
            exact
            component={() => (
              <Persistence>
                <SelectPlans />
              </Persistence>
            )}
          />
          <Route
            path='/app/my-account/:page'
            component={() => (
              <Persistence>
                <MyAccount />
              </Persistence>
            )}
          />
          <Route
            path='/app/my-bookmarks'
            exact
            component={() => (
              <Persistence>
                <BookmarksPage />
              </Persistence>
            )}
          />
          <Route
            path='/app/queries'
            exact
            component={() => (
              <Persistence>
                <Query />
              </Persistence>
            )}
          />
          <Route
            path='/app/account/confirm-email/:userID/:token+'
            component={ConfirmEmailPage}
          />
          <Route
            path='/app/account/confirm-email'
            component={ConfirmEmailPage}
          />
          <Route
            path='/app/account/reset-password/:email/:token+'
            component={ResetPassword}
          />
          <Route
            path='/app/account/reset-password/'
            component={ResetPassword}
          />
          <Route path='/app/account/register/' component={SignUp} />
          <Route
            path='/app/account/login/:id?'
            component={() => (
              <Persistence>
                <Login />
              </Persistence>
            )}
          />
          {/* <Route
            path='/app/search/:searchParam'
            component={() => (
              <Persistence>
                <SearchPage />
              </Persistence>
            )}
          /> */}
          <Route
            path='/app/search'
            exact
            component={() => (
              <Persistence>
                <SearchPage />
              </Persistence>
            )}
          />
          {/* <Route path="/app/:levelOne/:levelTwo/:levelThree/:document" component={() => (
            <Persistence>
              <Document />
            </Persistence>
          )} />
          <Route path="/app/:levelOne/:levelTwo/:document/:page" component={() => (
            <Persistence>
              <Document />
            </Persistence>
          )} /> */}
          <Route
            path='/app/:docSlug/:pageSlug/:scrollItem'
            component={() => (
              <Persistence>
                <Document />
              </Persistence>
            )}
          />
          <Route
            path='/app/:docSlug/:pageSlug'
            component={() => (
              <Persistence>
                <Document />
              </Persistence>
            )}
          />
          <Route
            path='/app/:docSlug'
            component={() => (
              <Persistence>
                <Document />
              </Persistence>
            )}
          />
          <Route
            path={config.HomeURL}
            exact
            component={() => (
              <Persistence>
                <Home />
              </Persistence>
            )}
          />
        </Switch>
      </Router>
    </React.Fragment>
  );
};

export default AppRoute;
